import { render, staticRenderFns } from "./BetTypeSelectorTerminal.vue?vue&type=template&id=a431f904&scoped=true"
import script from "./BetTypeSelectorTerminal.vue?vue&type=script&lang=js"
export * from "./BetTypeSelectorTerminal.vue?vue&type=script&lang=js"
import style0 from "./BetTypeSelectorTerminal.vue?vue&type=style&index=0&id=a431f904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a431f904",
  null
  
)

export default component.exports